import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
// Core components
import Card from 'components/core/Card';
import TextField from 'components/core/TextField';
// Models
import mWorkspace from 'models/cpm/workspace';
// Custom
import { errorShape } from 'constants/PropTypesShapes';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import { buildFormErrors, workspaceConstraints } from 'utils/Forms';

class WorkspaceAddEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { name },
      onErrorsChange,
      onValidate,
    } = this.props;

    const errors = buildFormErrors(
      {
        name,
      },
      workspaceConstraints,
    );
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate(mWorkspace.serialize({ name }));
    }
  }

  render() {
    const {
      fields: { name },
      errors,
      onFieldsChange,
    } = this.props;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row">
                    <div className="col-12 col-lg-6">
                      <TextField
                        margin="none"
                        label={<LocalizedMessage id="field.name" />}
                        value={name}
                        required
                        errorText={_get(errors, 'name')}
                        onChange={(value) => onFieldsChange({
                          name: value,
                        })}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

WorkspaceAddEditForm.propTypes = {
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
};

WorkspaceAddEditForm.defaultProps = {
  operationError: null,
  errors: null,
};

const mapFieldsToProps = {
  name: {
    resourceKey: 'name',
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.workspace,
  operationError: ownProps.operationError,
});

module.exports = withFormManagement(
  mapFieldsToProps,
  mapOwnPropsToResources,
  false,
)(WorkspaceAddEditForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/main/WorkspaceAddEditForm.js